// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"741":"6889fb40","787":"edc63dc8"}[chunkId] + ".chunk.js";
};